module.exports = __webpack_public_path__ + "img/clock.310c7af9.jpg";